import bookKeepingSettings from './book-keeping-settings';
import tenantJurisdictionDetails from './tenant-jurisdiction-details';
import tenantPayrollSettings from './tenant-payroll-settings';

let messages = Object.assign({}, bookKeepingSettings, tenantJurisdictionDetails, tenantPayrollSettings);

export default messages;
